import types from '../types/phone'
import {Map} from 'immutable'
import orchestratorTypes from '../types/orchestrator'

const initialRoot = Map({
  open: false,
  countryCode: '54',
  number: '',
  code: '',
  isSending: false,
  isSaving: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.SET_COUNTRY_CODE:
      return state.set('countryCode', action.payload.value)
    case types.SET_NUMBER:
      return state.set('number', action.payload.value)
    case types.SET_CODE:
      return state.set('code', action.payload.value)
    case types.SEND_CODE:
      return state.set('isSending', true)
    case types.SEND_CODE_SUCCESS:
      return state.merge({
        open: true,
        code: '',
        isSending: false,
        error: '',
      })
    case types.SEND_CODE_FAIL:
      return state.merge({
        isSending: false,
        error: action.payload.error,
      })
    case types.SET_OPEN_DIALOG:
      return state.set('open', action.payload.show)
    case types.SAVE:
      return state.set('isSaving', true)
    case types.SAVE_SUCCESS:
      return state.merge({
        isSaving: false,
        error: '',
        open: false,
      })
    case types.SAVE_FAIL:
      return state.merge({
        isSaving: false,
        error: action.payload.error,
      })
    case orchestratorTypes.START:
      return initialRoot
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/remove/reducers/phone.js